"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formReducer = exports.initialState = void 0;
exports.initialState = {
    name: { value: "", touched: false, required: true },
    site_url: { value: "", touched: false, required: true },
    contact_name: { value: "", touched: false, required: true },
    email: { value: "", touched: false, required: true },
    password: { value: "", touched: false, required: true },
    errors: {},
};
var formReducer = function (state, action) {
    var _a;
    var _b = action.field, field = _b === void 0 ? "" : _b, _c = action.value, value = _c === void 0 ? "" : _c, _d = action.errors, errors = _d === void 0 ? {} : _d;
    var currentValues = field ? state[field] : {};
    switch (action.type) {
        case "SET_FIELD":
            return __assign(__assign({}, state), (_a = {}, _a[field] = __assign(__assign({}, currentValues), { value: value, touched: true }), _a));
        case "SET_ERROR":
            return __assign(__assign({}, state), { errors: __assign({}, errors) });
        case "CLEAR_ERRORS":
            return __assign(__assign({}, state), { errors: {} });
        default:
            return state;
    }
};
exports.formReducer = formReducer;
